import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  Divider,
  Grid,
  InputAdornment,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import BreadCrumb from "../common/BreadCrumb";
import ButtonComponent from "../common/Button";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as FoodBar } from "../../assets/images/FoodBar.svg";
import SearchInput from "../common/Input/TextInput";
import { CiSearch } from "react-icons/ci";
import { FaPlus } from "react-icons/fa6";
import { FiDownload } from "react-icons/fi";
import { IoPrintOutline } from "react-icons/io5";
import { SurfaceData, generateColumns } from "./helper";
import TableContainerComp from "../common/Table/TableContainer";
import { useDispatch, useSelector } from "react-redux";
import { getSurfaces } from "../../store/surface/surface.slice";

export const BusinessWiseProfile = () => {
  const dispatch = useDispatch();
  const {
    surfaces: { data: SurfaceData, total_data },
    isLoading,
  } = useSelector((state) => state.surface);
  const { generalInfoDetails } = useSelector(
    (state) => state.settings.generalInfo
  );
  const location = useLocation();
  const columns = generateColumns(generalInfoDetails?.dateFormat);
  const stores = [
    {
      img: null,
      storeName: "K Mart",
      place: "New York",
    },
    {
      img: null,
      storeName: "E Mart",
      place: "Manhattan",
    },
    {
      img: null,
      storeName: "H Mart",
      place: "Manhattan",
    },
    {
      img: null,
      storeName: "E Mart",
      place: "Manhattan",
    },
  ];
  const [reviewFilter, setReviewFilter] = useState("1 month");
  const [expanded, setExpanded] = useState(false);
  const [redFlag, setRedFlag] = useState(true);
  const [searchState, setSearchState] = useState("");

  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });
  const [sorting, setSorting] = useState({
    order: "asc",
    orderBy: "createdAt",
  });

  const getSurfacesList = (details) => {
    dispatch(
      getSurfaces({
        page: details?.page || pagination.page,
        limit: details?.pageSize || pagination.pageSize,
        sortby: details?.orderBy || sorting.orderBy,
        sorttype: details?.order || sorting.order,
        q: details?.q || "",
        bussinessId: details?.bussinessId || location?.state?._id,
      })
    );
  };

  const pageHandler = (page, pageSize) => {
    setPagination({ page: page, pageSize: pageSize });
    getSurfacesList({
      page,
      pageSize,
    });
  };
  const searchHandler = (e) => {
    console.log(e, "value");
    getSurfacesList({ page: 1, q: e?.target?.value || "" });
    setPagination((prev) => ({ ...prev, page: 1 }));
    setSearchState(e?.target?.value || "");
  };

  const sortingHandler = (orderByCol) => {
    console.log(orderByCol, sorting, "orderBy");
    const isAsc = sorting?.orderBy === orderByCol && sorting?.order === "asc";
    setSorting({ order: isAsc ? "desc" : "asc", orderBy: orderByCol });
    getSurfacesList({ order: isAsc ? "desc" : "asc", orderBy: orderByCol });
  };

  useEffect(() => {
    getSurfacesList();
  }, [location?.state]);

  return (
    <Box>
      <BreadCrumb
        title="Business Details"
        parents={["Surface Management"]}
        parentsURL={["/surface"]}
      />
      <Box className="mx-2 business-profile">
        <Grid container>
          <Grid item xs={10} lg={7}>
            <Card>
              <Grid container spacing={2} className="text-start p-4 pb-0">
                <Grid item xs={5}>
                  <Box>
                    <h1 className="md:text-lg xl:text-xl font-semibold">
                      Business Details
                    </h1>
                    <Box className="flex items-center p-3">
                      <img
                        className="rounded-lg business-profile-img"
                        src={location?.state?.profileUrl || "/images/store.png"}
                        style={{ width: "60px", height: "60px" }}
                        alt=""
                      />
                      <Box className="ms-2">
                        <Box className="flex items-center text-medium">
                          <h3 className="text-zinc-700 me-2">
                            {location?.state?.name || " "}
                          </h3>
                          <span
                            className="inline-block p-2 rounded-full"
                            style={{ backgroundColor: "#FCF0C6" }}
                          >
                            <FoodBar className="md:w-4 md:h-4 xl:w-5 xl:h-5" />
                          </span>
                        </Box>
                        <p className="text-zinc-400 md:text-xs xl:text-sm">
                          {location?.state?.street}, {location?.state?.state},
                        </p>
                        <p className="text-zinc-400 md:text-xs xl:text-sm">
                          {location?.state?.country}
                        </p>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                <Divider
                  orientation="vertical"
                  variant="middle"
                  style={{ height: "150px" }}
                />
                <Grid item xs={6}>
                  <Box>
                    <h1 className="md:text-lg xl:text-xl font-semibold">
                      Partners
                    </h1>
                    <Box className="flex p-3 text-start items-center">
                      <Box className="flex flex-col items-center me-3">
                        <img
                          src="/images/dummy-user.jpg"
                          alt=""
                          className="partner-profile-img"
                        />
                        <p className="md:text-xs xl:text-sm whitespace-nowrap">
                          Tony Stark
                        </p>
                        <p className="text-zinc-400 md:text-xs xl:text-sm">
                          Owner
                        </p>
                      </Box>
                      {location?.state?.businessPartners?.map((partner) => {
                        return (
                          <Box className="flex flex-col items-center me-3">
                            <img
                              src={
                                partner?.profileUrl || "/images/dummy-user.jpg"
                              }
                              alt=""
                              className="partner-profile-small-img"
                            />
                            <p className="md:text-xs xl:text-sm whitespace-nowrap">
                              {`${partner?.fname || ""} ${
                                partner?.lname || ""
                              }`}
                            </p>
                          </Box>
                        );
                      })}

                      {/* <Box className="flex flex-col items-center me-3">
                        <img
                          src="/images/dummy-user.jpg"
                          alt=""
                          style={{ height: "50px", width: "50px" }}
                        />
                        <p className="md:text-xs xl:text-sm whitespace-nowrap">
                          Eric Young
                        </p>
                      </Box>
                      <Box className="flex flex-col items-center me-3">
                        <img
                          src="/images/dummy-user.jpg"
                          alt=""
                          style={{ height: "50px", width: "50px" }}
                        />
                        <p className="md:text-xs xl:text-sm whitespace-nowrap">
                          Eric Young
                        </p>
                      </Box> */}
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Box>
              {/* <Box className="text-start flex justify-between mx-2"> */}
              <Box className="flex items-center justify-between my-3 w-full">
                <Box>
                  <SearchInput
                    placeholder="Search by text"
                    wrapperClassName="me-4"
                    isShowError={false}
                    value={searchState}
                    onChange={searchHandler}
                    startAdornment={
                      <InputAdornment position="start">
                        <IconButton>
                          <CiSearch />
                        </IconButton>
                      </InputAdornment>
                    }
                    inputClassName="rounded-lg"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "10px",
                        border: 0,
                      },
                    }}
                  />
                </Box>
                <Box className="flex items-center">
                  {/* <ButtonComponent
                    btnText="Clear Filter"
                    style={{
                      padding: "7px 20px",
                      backgroundColor: "#263238",
                      "&:hover": { backgroundColor: "#263238" },
                    }}
                    onClick={() => {
                      searchHandler();
                    }}
                  /> */}
                  <p className="text-lg text-zinc-400 ms-4">
                    Total surfaces :{" "}
                    <span className="text-black">{total_data}</span>
                  </p>
                </Box>
              </Box>
              {/* </Box> */}
              <Box>
                <TableContainerComp
                  columns={columns}
                  rows={SurfaceData}
                  pagination={true}
                  hasLink={true}
                  isLoading={isLoading}
                  sortingDetails={sorting}
                  sortingHandler={sortingHandler}
                  navigateURL={"/surface/surfacewise-profile"}
                  paginationDetails={{
                    ...pagination,
                    total_data,
                    pageHandler: pageHandler,
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
